// only export what we use

// eslint-disable-next-line no-restricted-syntax
import { scaleBand } from '@visx/scale';
// Creating a combination scale that adds a timeUnit function
// I may want to adjust how we are doing this.
function scaleBandTime(config) {
  const scale = scaleBand(config);
  scale.timeUnit = function () {
    return config === null || config === void 0 ? void 0 : config.timeUnit;
  };
  return scale;
}
export { coerceNumber, getTicks, scaleBand, scaleLinear, scaleLog, scaleOrdinal, scaleTime, scalePoint, inferScaleType } from '@visx/scale';
export { scaleBandTime };